<template>
  <div
    @click="click"
    class="single-practice"
    :class="{
      done: done,
      'reduced-opacity': reducedOpacity,
      'not-displayed': !displayed,
      focus: focus
    }"
  ></div>
</template>

<script>
export default {
  props: {
    done: {
      type: Boolean,
      required: true
    },
    reducedOpacity: {
      type: Boolean,
      default: false,
      required: true
    },
    displayed: {
      type: Boolean,
      required: true
    },
    focus: {
      type: Boolean,
      required: true
    },
    date: {
      type: String
    }
  },
  methods: {
    click() {
      this.$emit("click");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../style/variables";

.single-practice {
  cursor: pointer;
  background: rgb(236, 236, 236);
  border: 1px solid rgb(220, 220, 220);
  height: $squareSize;
  width: $squareSize;
  position: relative;
}
.done {
  background: #00bd29;
}
.reduced-opacity {
  opacity: 0.65;
}
.focus {
  border: 2px solid rgb(99, 97, 97);
}
.not-displayed {
  border: 0;
  background: transparent;
}
</style>